import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Select, InputNumber } from 'antd';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import {
    fSearchAction,
    fGenderAction,
    fCategoriesAction,
    fDatesAction,
    fAdvanceSearchAction,
    fProgramTypeAction,
    fCityAction,
    fRadiusAction,
    fLatLongAction,
    filterLatLongAction,
    fAgeGroupAction,
    fGrageAction,
    fPriceRangeAction,
    fWeekDayAction,
    fEzProEatingAction,
    fCampersAction,
    clearAllFitlerAction,
    fCamperDisplayAction,
    fIsonlineOffline,
    clearSingleFitlerAction,
    clearDateFitlerAction,
    fPageNoAction
} from '../../store/pFilter';

import { filterProgramsAction, setSubCatAction } from '../../store/program';

import { dateFormat, programTypes, daysArr, PriceArr, gradeArr, ageArr, removeTime2, genders3 } from '../../helper';
import settings from '../../config/settings';

const { RangePicker } = DatePicker;
const { Option } = Select;

const BRAND  = '#842014';
const ORANGE = '#f9a720';

// --- COMPACT STYLING FOR REDUCED HEIGHT ---
const labelStyle = { 
    color: 'rgba(255,255,255,0.95)', 
    fontSize: '0.8rem', 
    fontWeight: 500, 
    display: 'block', 
    marginBottom: 2 // Minimal margin
};

const inputStyle = { 
    width: '100%', 
    padding: '6px 12px', // Tighter padding for less height
    borderRadius: 8, 
    border: 'none', 
    outline: 'none', 
    background: '#fff', 
    color: '#111827', 
    fontSize: '0.85rem' 
};

const MainFilterNew = props => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [cityInput, setCityInput] = useState(props.city || '');
    const { preList } = props;

    useEffect(() => {
        if (props.isHome) {
            props.fSearchAction('');
        }
    }, []);

    // Keep local city input in sync when Redux city changes externally (e.g. camper select, clear all)
    useEffect(() => {
        setCityInput(props.city || '');
    }, [props.city]);

    const handleCityChange = val => {
        setCityInput(val);
        if (!val) {
            props.fCityAction('');
            props.filterLatLongAction('', '');
        }
    };

    const handleCitySelect = city => {
        setCityInput(city);
        props.fCityAction(city);
        getLatLong(city);
    };

    const handleCategory = category => {
        let updatedCategories = [];
        let updatedSubCategories = [];

        if (props.categories.includes(category._id)) {
            updatedCategories = props.categories.filter(id => id !== category._id);
        } else {
            updatedCategories = [...props.categories, category._id];
        }

        updatedSubCategories = updatedCategories
            .map(catId => {
                const cat = preList.category.find(c => c._id === catId);
                if (!cat || !cat.subCategory?.length) return null;
                return { categoryname: cat.name, catlist: cat.subCategory };
            })
            .filter(Boolean);

        props.fCategoriesAction(updatedCategories);
        props.setSubCatAction(updatedSubCategories);
    };

    const handleClearAllFilters = () => {
        props.clearAllFitlerAction();
        props.setSubCatAction([]);
    };

    const handleWeekDay = e => {
        if (props.weekDays.includes(e)) {
            props.fWeekDayAction(props.weekDays.filter(item => item !== e));
        } else {
            props.fWeekDayAction([...props.weekDays, e]);
        }
    };

    const handleCheckbox = e => {
        if (e.target.checked) {
            props.fGenderAction(parseInt(e.target.value));
        } else {
            props.fGenderAction('');
        }
    };

    const handleRadio = e => {
        if (e.target.checked) {
            props.fIsonlineOffline(parseInt(e.target.value));
        } else {
            props.fIsonlineOffline(null);
        }
    };

    const handleCamperSelect = e => {
        let localCamper = props.camperList.filter(el => e.find(i => el._id === i) && el).map(n => n._id);
        props.fCamperDisplayAction(localCamper);
        if (e.length === 1) {
            const singleCamper = props.camperList.filter(el => el._id === e)[0];
            props.fCityAction(singleCamper.city);
            props.fGenderAction(singleCamper.gender);
            props.fAgeGroupAction(`${singleCamper.age}-${singleCamper.age}`);
            props.fGrageAction(singleCamper.grade);
        } else {
            const multipleCamper = props.camperList.filter(el => e.find(i => el._id === i) && el).map(camper => ({
                camperId: camper._id,
                gender: camper.gender,
                age: camper.age,
                grade: camper.grade,
                city: camper.city
            }));
            props.fCityAction('');
            props.fGenderAction('');
            props.fAgeGroupAction('');
            props.fGrageAction('');
            props.fCampersAction(multipleCamper);
        }
    };

    const handleFiterSearch = e => {
        props.fPageNoAction(1);
        e.preventDefault();
        if (props.isHome) {
            setIsRedirect(true);
        } else {
            let {
                keywordSearch, gender, ageGroup, grade, startDate, endDate,
                programType, city, radius, priceRange, ezProRating, categories,
                flat, flong, lat, long, pageNo, limit, weekDays, subCategories, campers, isOnline
            } = props;

            let params = {
                keywordSearch, gender, ageGroup, grade, startDate, endDate,
                programType, city, radius, priceRange, ezProRating, flat, flong, lat, long,
                pageNo: 1, limit,
                weekDays: weekDays.length ? JSON.stringify(weekDays) : '',
                categories: categories.length ? JSON.stringify(categories) : '',
                subCategories: subCategories.length ? JSON.stringify(subCategories) : '',
                campers: campers.length ? JSON.stringify(campers) : '',
                specialDeals: window.location.pathname.includes('special-offers'),
                isOnline,
            };

            if (window.location.href.includes('sports-international-camps')) {
                params.campId = settings.api.sportInternationalCamp;
            } else {
                params.campId = props.isDistrictCamps ? settings.api.districtCamp : '';
            }

            props.filterProgramsAction(params);
            const element = document.getElementById('camps_lists');
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
    };

    const getLatLong = city => {
        geocodeByAddress(city)
            .then(results => {
                for (let i = 0; i < results.length; i++) {
                    for (let j = 0; j < results[i].address_components.length; j++) {
                        for (let k = 0; k < results[i].address_components[j].types.length; k++) {
                            if (results[i].address_components[j].types[k] === 'locality') {
                                const cityName = results[i].address_components[j].long_name;
                                props.fCityAction(cityName || undefined);
                            }
                        }
                    }
                }
                return results;
            });
        geocodeByAddress(city)
            .then(results => getLatLng(results[0]))
            .then(latLng => props.filterLatLongAction(latLng))
            .catch(error => console.error('Error', error));
    };

    const disabledDate = current => current && current < moment().startOf('day');

    return (
        <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{
                width: '100%',
                maxWidth: '420px',
                marginLeft: '3%',
                background: 'rgba(132, 32, 20, 0.97)',
                borderRadius: 16,
                boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                border: '1px solid rgba(255,255,255,0.15)',
                maxHeight: 'calc(100vh - 160px)',
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
            }}
        >
            <style>{`.main_filter_wrapper ::-webkit-scrollbar { display: none; }`}</style>
            {isRedirect ? <Redirect to="/camps" /> : ''}

            {/* ── Category Header (Tightened) ── */}
            {!props.hideCategory && !props.isDistrictFilter && (
                <div style={{
                    background: 'rgba(0,0,0,0.25)',
                    padding: '12px 16px 8px',
                    display: 'flex',
                    gap: 8,
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    borderRadius: '16px 16px 0 0',
                }}>
                    {preList.category.map(item => (
                        <OverlayTrigger
                            key={item._id}
                            delay={{ show: 10, hide: 200 }}
                            overlay={<Tooltip className="dark_tooltip">{item.name}</Tooltip>}
                        >
                            <div style={{ position: 'relative', flexShrink: 0 }}>
                                <input
                                    type="checkbox"
                                    value={item._id}
                                    checked={props.categories.includes(item._id)}
                                    onChange={() => handleCategory(item)}
                                    style={{
                                        position: 'absolute', inset: 0, opacity: 0,
                                        cursor: 'pointer', zIndex: 9, width: '100%', height: '100%',
                                    }}
                                />
                                <div style={{
                                    width: 36, height: 36, borderRadius: '50%',
                                    background: props.categories.includes(item._id) ? ORANGE : 'rgba(255,255,255,0.15)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    transition: 'all 0.2s',
                                }}>
                                    <img src={item.icon} alt={item.name} width={20} height={20} style={{ objectFit: 'contain' }} />
                                </div>
                            </div>
                        </OverlayTrigger>
                    ))}
                </div>
            )}

            {/* ── Form Container (Reduced Gap & Padding) ── */}
            <form onSubmit={handleFiterSearch} style={{ padding: '12px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>

                {props.hideCategory && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                        <span style={{ color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.75rem', opacity: 0.8 }} onClick={handleClearAllFilters}>Clear All</span>
                        <h5 style={{ color: '#fff', margin: 0 }}>Search</h5>
                    </div>
                )}

                {/* Keyword Search */}
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <label style={labelStyle}>Keyword Search</label>
                        {props.loggedIn && (
                            <Link to="/auto-scheduler" style={{
                                background: ORANGE, color: '#fff', fontSize: '0.65rem',
                                fontWeight: 700, padding: '2px 8px', borderRadius: 4,
                                textDecoration: 'none', marginBottom: 4
                            }}>Auto Scheduler</Link>
                        )}
                    </div>
                    <input
                        type="text"
                        value={props.keywordSearch}
                        placeholder="Keyword or Program Name"
                        onChange={e => props.fSearchAction(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                {/* Participant Select */}
                {props.loggedIn && (
                    <div>
                        <label style={labelStyle}>Search by User</label>
                        <Select
                            onChange={handleCamperSelect}
                            mode="multiple"
                            disabled={!props.camperList.length}
                            size="small" // Small size for less height
                            style={inputStyle}
                            placeholder="Select Participant Profile"
                            value={props.camperDisplay}
                            getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                        >
                            {props.camperList.map(item => (
                                <Option key={item._id} value={item._id}>{item.firstName} {item.lastName || ''}</Option>
                            ))}
                        </Select>
                    </div>
                )}

                {/* City & Radius Row */}
                <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ flex: 2, position: 'relative' }}>
                        <label style={labelStyle}>City</label>
                        <PlacesAutocomplete
                            value={cityInput}
                            onChange={handleCityChange}
                            onSelect={handleCitySelect}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                    <input
                                        {...getInputProps({
                                            placeholder: 'City...',
                                            style: inputStyle,
                                        })}
                                        disabled={props.isOnline !== '' && props.isOnline === 1}
                                    />
                                    {(loading || suggestions.length > 0) && (
                                        <div style={{
                                            position: 'absolute', top: '100%', left: 0,
                                            width: '100%', zIndex: 9999,
                                            background: '#fff', borderRadius: 8, marginTop: 4,
                                            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                                            maxHeight: 300, overflowY: 'auto',
                                        }}>
                                            {loading && <div style={{ padding: '8px 12px', color: '#555', fontSize: '0.85rem' }}>Loading...</div>}
                                            {suggestions.map(suggestion => (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        style: {
                                                            padding: '8px 12px', cursor: 'pointer', fontSize: '0.85rem',
                                                            background: suggestion.active ? '#f3f4f6' : '#fff',
                                                            borderBottom: '1px solid #f1f5f9',
                                                        }
                                                    })}
                                                >
                                                    {suggestion.description}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={labelStyle}>Radius</label>
                        <InputNumber
                            placeholder="Miles"
                            size="small"
                            value={props.radius}
                            onChange={e => props.fRadiusAction(e)}
                            style={inputStyle}
                            disabled={props.isOnline === 1}
                        />
                    </div>
                </div>

                {/* Gender Row (Tighter) */}
                <div style={{ display: 'flex', gap: 14, padding: '2px 0' }}>
                    {genders3.map(item => (
                        <label key={item.value} style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#fff', cursor: 'pointer', fontSize: '0.8rem' }}>
                            <input
                                type="checkbox"
                                disabled={props.campers.length > 1}
                                checked={props.gender === item.value}
                                onChange={handleCheckbox}
                                value={item.value}
                                style={{ width: 14, height: 14 }}
                            />
                            {item.label}
                        </label>
                    ))}
                </div>

                {/* Age & Grade Row */}
                <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ flex: 1 }}>
                        <label style={labelStyle}>Age</label>
                        <Select
                            disabled={props.campers.length > 1}
                            size="small"
                            style={inputStyle}
                            placeholder="Age"
                            onChange={e => props.fAgeGroupAction(e)}
                            value={props.ageGroup || null}
                            getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                        >
                            <Option value="">Age</Option>
                            {ageArr.map(item => <Option key={item} value={item}>{item}</Option>)}
                        </Select>
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={labelStyle}>Grade</label>
                        <Select
                            disabled={props.campers.length > 1}
                            size="small"
                            style={inputStyle}
                            placeholder="Grade"
                            onChange={e => props.fGrageAction(e)}
                            value={props.grade || null}
                            placement="bottomRight"
                            getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                        >
                            <Option value="">Grade</Option>
                            {gradeArr.map(item => <Option key={item} value={item}>{item}</Option>)}
                        </Select>
                    </div>
                </div>

                {/* Date Picker */}
                <div>
                    <label style={labelStyle}>Select Dates</label>
                    <RangePicker
                        size="small"
                        style={{ width: '100%', borderRadius: 8 }}
                        disabledDate={disabledDate}
                        onChange={e => props.fDatesAction([
                            new Date(removeTime2(e[0]._d)).getTime(),
                            new Date(removeTime2(e[1]._d)).getTime()
                        ])}
                        value={props.startDate ? [
                            moment.utc(parseInt(props.startDate)),
                            moment.utc(parseInt(props.endDate))
                        ] : null}
                    />
                </div>

                {/* Advanced Toggle (Reduced Margin) */}
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff', cursor: 'pointer', margin: '2px 0' }}>
                    <input
                        type="checkbox"
                        checked={props.advanceSearch}
                        onChange={props.fAdvanceSearchAction}
                        style={{ width: 14, height: 14 }}
                    />
                    <span style={{ fontWeight: 600, fontSize: '0.8rem' }}>Advanced Search</span>
                </label>

                {/* Advanced Search Options */}
                {props.advanceSearch && (
                    <>
                        <div>
                            <label style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff', cursor: 'pointer', fontSize: '0.8rem' }}>
                                <input
                                    type="checkbox"
                                    value="0"
                                    checked={props.isOnline !== '' && props.isOnline === 0}
                                    onChange={handleRadio}
                                    style={{ width: 14, height: 14 }}
                                />
                                Remove Online Programs
                            </label>
                        </div>

                        <div>
                            <label style={labelStyle}>Program Type</label>
                            <Select
                                size="small"
                                style={inputStyle}
                                placeholder="Select Program Type"
                                onChange={e => props.fProgramTypeAction(e)}
                                value={props.programType || null}
                                getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                            >
                                {programTypes.map(item => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                            </Select>
                        </div>

                        <div>
                            <label style={labelStyle}>Start Day of Program</label>
                            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                {daysArr.map((day, i) => (
                                    <label key={i} style={{
                                        display: 'flex', flexDirection: 'column', alignItems: 'center',
                                        gap: 4, cursor: 'pointer'
                                    }}>
                                        <input
                                            type="checkbox"
                                            value={i}
                                            checked={props.weekDays.includes(i)}
                                            onChange={() => handleWeekDay(i)}
                                            style={{ width: 14, height: 14 }}
                                        />
                                        <span style={{
                                            fontSize: '0.7rem', color: '#fff',
                                            background: props.weekDays.includes(i) ? ORANGE : 'rgba(255,255,255,0.2)',
                                            padding: '2px 6px', borderRadius: 4, transition: 'all 0.2s'
                                        }}>{day}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: 8 }}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>Price Range</label>
                                <Select
                                    size="small"
                                    style={inputStyle}
                                    placeholder="Select Price Range"
                                    onChange={e => props.fPriceRangeAction(e)}
                                    value={props.priceRange || null}
                                    getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                                >
                                    <Option value="">Select Price Range</Option>
                                    {PriceArr.map(item => <Option key={item} value={item}>{item}</Option>)}
                                </Select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>EZPRO Rating</label>
                                <Select
                                    size="small"
                                    style={inputStyle}
                                    placeholder="Select Rating"
                                    onChange={e => props.fEzProEatingAction(e)}
                                    value={props.ezProRating || null}
                                    getPopupContainer={() => document.querySelector('.main_filter_wrapper') || document.body}
                                >
                                    <Option value="">Select Rating</Option>
                                    {[1,2,3,4,5].map(n => <Option key={n} value={n}>{n}</Option>)}
                                </Select>
                            </div>
                        </div>
                    </>
                )}

                {/* Search Button (Slimmer) */}
                <button
                    type="submit"
                    style={{
                        width: '100%', background: ORANGE, color: '#fff',
                        border: 'none', borderRadius: 8, padding: '10px 0',
                        fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        boxShadow: '0 4px 15px rgba(249,167,32,0.3)',
                        transition: 'background 0.2s',
                        marginTop: 4
                    }}
                >
                    <Search size={16} />
                    Search Programs
                </button>
            </form>
        </motion.div>
    );
};

// ... Boilerplate Redux mapping remains the same ...
const mapStateToProps = state => {
    let { loggedIn } = state.user;
    let { preList, fSubcategory, camperList } = state.program;
    let {
        keywordSearch, gender, ageGroup, grade, startDate, endDate,
        programType, weekDay, city, radius, priceRange, ezProRating,
        categories, flat, flong, lat, long, pageNo, limit,
        weekDays, subCategories, advanceSearch, campers, camperDisplay,
        isOnline, isDistrictCamps
    } = state.pFilter;

    return {
        fSubcategory, loggedIn, preList,
        keywordSearch, gender, ageGroup, grade, startDate, endDate,
        programType, weekDay, city, radius, priceRange, ezProRating,
        categories, flat, flong, lat, long, pageNo, limit,
        weekDays, subCategories, advanceSearch, campers, camperList,
        camperDisplay, isOnline, isDistrictCamps,
    };
};

const mapDispatchToProps = dispatch => ({
    fSearchAction:            params => dispatch(fSearchAction(params)),
    fGenderAction:            params => dispatch(fGenderAction(params)),
    fCategoriesAction:        params => dispatch(fCategoriesAction(params)),
    fDatesAction:             params => dispatch(fDatesAction(params)),
    fProgramTypeAction:       params => dispatch(fProgramTypeAction(params)),
    fCityAction:              params => dispatch(fCityAction(params)),
    fRadiusAction:            params => dispatch(fRadiusAction(params)),
    filterLatLongAction:      params => dispatch(filterLatLongAction(params)),
    fAgeGroupAction:          params => dispatch(fAgeGroupAction(params)),
    fGrageAction:             params => dispatch(fGrageAction(params)),
    fPriceRangeAction:        params => dispatch(fPriceRangeAction(params)),
    fWeekDayAction:           params => dispatch(fWeekDayAction(params)),
    filterProgramsAction:     params => dispatch(filterProgramsAction(params)),
    fEzProEatingAction:       params => dispatch(fEzProEatingAction(params)),
    setSubCatAction:          params => dispatch(setSubCatAction(params)),
    fCampersAction:           params => dispatch(fCampersAction(params)),
    fCamperDisplayAction:     params => dispatch(fCamperDisplayAction(params)),
    clearSingleFitlerAction:  params => dispatch(clearSingleFitlerAction(params)),
    fIsonlineOffline:         params => dispatch(fIsonlineOffline(params)),
    fPageNoAction:            params => dispatch(fPageNoAction(params)),
    fAdvanceSearchAction:          () => dispatch(fAdvanceSearchAction()),
    clearDateFitlerAction:         () => dispatch(clearDateFitlerAction()),
    clearAllFitlerAction:          () => dispatch(clearAllFitlerAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainFilterNew);